import { render, staticRenderFns } from "./main.vue?vue&type=template&id=f6b9d50c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b9d50c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6b9d50c')) {
      api.createRecord('f6b9d50c', component.options)
    } else {
      api.reload('f6b9d50c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=f6b9d50c&scoped=true", function () {
      api.rerender('f6b9d50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/analytics/main.vue"
export default component.exports